import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DemoApiService {
  
  constructor(private http: HttpClient) {}

  getSuccess(): Observable<any> {
    return this.http.get('api/navigation/routes');
  }

  getForbidden(): Observable<any> {
    return this.http.get('api/navigation/forbidden');
  }

  getNotFound(): Observable<any> {
    return this.http.get('api/navigation/notfound');
  }
}